import { isSyncOperationStatus } from "../valueObjects/syncOperationStatuses";
import { isSyncOperationType } from "../valueObjects/syncOperationTypes";
import { assertString } from "../utils/assertions";
import { createUuid } from "../utils/id";
import { nowIso } from "../utils/timestamps";

export const createSyncOperation = ({
  id = createUuid(),
  organizationId,
  vesselId,
  voyageId,
  tripId,
  entityType,
  entityId,
  entityRevision,
  operation,
  status,
  createdAt = nowIso(),
  updatedAt = createdAt,
  attempts = 0,
  lastError,
}) => {
  assertString(id, "syncOperation.id");
  assertString(organizationId, "syncOperation.organizationId");
  assertString(vesselId, "syncOperation.vesselId");
  assertString(entityType, "syncOperation.entityType");
  assertString(entityId, "syncOperation.entityId");

  if (!isSyncOperationType(operation)) {
    throw new Error("syncOperation.operation must be a valid sync operation");
  }

  if (!isSyncOperationStatus(status)) {
    throw new Error("syncOperation.status must be a valid sync status");
  }

  return {
    id,
    organizationId,
    vesselId,
    voyageId,
    tripId,
    entityType,
    entityId,
    entityRevision,
    operation,
    status,
    createdAt,
    updatedAt,
    attempts,
    lastError,
  };
};
